import $ from 'jquery';

const SELECTORS = {
  workPageContent: '.work-page-content',
  backLink: '.back-link',
};

export default class WorkHistoryManager {
  constructor(workPage, workPageNav) {
    this.workPage = workPage;
    this.workPageNav = workPageNav;
    this.quoteService = workPage.quoteService;
    this.workPageContent = $(SELECTORS.workPageContent);
  }

  init() {
    this._initializeState();
    this._bindHistoryStateChange();
    this._bindBackLink();
  }

  _initializeState() {
    setTimeout(() => {
      this.quoteService.debouncedGetQuote();

      if (History.getState) {
        var stateData = History.getState().data;
        if (window.Application.url_state_params) {
          var url = new RegExp('[\?].*$').exec(window.location.href)[0];

          Object.assign(stateData, window.Application.url_state_params);
          History.pushState(stateData, '', url);
        }
        this.workPageNav.updatePageUsingState(stateData);
      }

      this.workPage.updateButtonStates();
    });
  }

  _bindHistoryStateChange() {
    History.Adapter.bind(window, 'statechange', () => {
      return this.workPageNav.updatePageUsingState(History.getState().data);
    });
  }

  _bindBackLink() {
    this.workPageContent.on('click', SELECTORS.backLink, function (e) {
      e.preventDefault();
      History.back();
    });
  }
}
